import FileDisplay from 'ext-ui/components/FileDisplay/FileDisplay'
import React from 'react'
import { useTranslate } from 'src/localization/Trns'
import {
  ExpensePolicyResponse,
  ManagerApprovalRulesResponse,
} from 'src/models/organizations.models'

interface ExpensePolicyUploadBoxContentProps {
  rules?: ManagerApprovalRulesResponse
  policy?: ExpensePolicyResponse
}

const ExpensePolicyUploadBoxContent: React.FC<
  ExpensePolicyUploadBoxContentProps
> = (props): React.ReactElement => {
  const translate = useTranslate()
  const { rules, policy } = props

  const isPolicyAssistantEnabled = rules?.policyAssistantEnabled

  return (
    <div className={'flex-column gap-6'}>
      <div className={'flex-column gap-2'}>
        <span className={'font-form-label'}>
          {translate('AI Policy Assistant')}
        </span>
        <span className={'font-regular text-primary'}>
          {translate(isPolicyAssistantEnabled ? 'ON' : 'OFF')}
        </span>
      </div>
      {isPolicyAssistantEnabled && policy && (
        <div className={'flex-column gap-2'}>
          <span className={'font-form-label'}>
            {translate('Expense Policy')}
          </span>
          <FileDisplay {...policy} data-testid={'expensePolicy'} />
        </div>
      )}
    </div>
  )
}

export default ExpensePolicyUploadBoxContent
